<template>
  <div class="InMailDetail">
    <div v-loading="loading"></div>
    <div v-if="clientWidth < 751" class="InMailDetail-content">
      <div class="InMailList-d-s-title" v-if="ChatList.length > 0 && ChatList[0].type == 0">系统通知</div>
      <div class="InMailList-d-s-title" v-if="ChatList.length > 0 && ChatList[0].type == 1">提问对话</div>
      <div class="InMailList-d-s-title" v-if="ChatList.length > 0 && ChatList[0].type == 3">合作伙伴审核通过</div>
      <div class="InMailList-d-s-title" v-if="ChatList.length > 0 && ChatList[0].type == 4">合作伙伴审核拒绝</div>
      <div class="chat-box" ref="chatBox">
        <div class="chat-item" v-for="item in ChatList" :key="item.id" :class="!item.isMy ? 'chat-item-left' : 'chat-item-right'">
          <div class="InMailList-d-s-deta co-999 tc">{{item.dataTimeString}}</div>
          <div class="InMailList-d-s-content flex">
            <div class="InMailList-d-s-content-icon flex1" v-if="!item.isMy"><img src="@/assets/PC/home/znx.png"></div>
            <div class="InMailList-d-s-content-icon flex1" v-else><img src="@/assets/PC/header/user_slices/user1.png"></div>
            <div class="InMailList-d-s-content-text">
              <b v-if="item.type != 1">亲爱的{{ Info.name }}，你好：</b> 
              <p :class="item.type != 1 ? 'p-top' : ''" v-html="item.content"></p> 
              <div class="san0" v-if="!item.isMy"></div>
              <div class="san1" v-else></div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-input" v-if="IsChat">
        <div class="chat-input-content">
          <input type="text" v-model="params.content">
          <button @click="handleSend">发送</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetSystemMessageInfo, Question } from "@/api/profile.js";

export default {
  name: "InMailDetail",
  data() {
    return {
      loading: true,                           // !loading
      sendLoading: false,
      Info: this.$store.state.Infos,           // !个人信息
      DetailId: '',                            // !详情Id
      ChatList: [],                        // !数据对象
      IsChat: false,                       // !是否可以聊天
      params: {
        content: '',
        forumQuestionId: '',
      },
    };
  },
  mounted() {
    if(!this.$store.state.token) {
      this.$router.push('/');
    }else {
      if(this.$store.state.clientWidth > 768) {
        this.$router.push('/Home/InMail');
      }else {
        if(this.$route.query.forumQuestionId) {
          this.params.forumQuestionId = this.$route.query.forumQuestionId;
        }
        this.DetailId = this.$route.query.id;
        this.GetInit();
      }
    }
  },
  methods: {
    GetInit() {
      const Id = {messageId: this.DetailId};
      GetSystemMessageInfo(Id).then(res => {
        if(res.status == 1) {
          this.ChatList = res.data;
          if(res.data.length > 0 && res.data[0].type == 1){
            this.IsChat = true;
            this.$nextTick(()=> {
              this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight;
            })
          }
        } else {
          this.$toast(res.message);
        }
        this.loading = false;
      })
    },
    // !发送消息
    handleSend() {
      if(this.sendLoading) return;
      if(!this.params.content) {
        this.$toast('请输入内容');
        return;
      }
      this.sendLoading = true;
      Question(this.params).then(res => {
        this.sendLoading = false;
        if(res.status == 1) {
          this.$toast('发送成功');
          this.ChatList.push({
            id: '',
            dataTimeString: new Date().toLocaleString(),
            content: this.params.content,
            isMy: true,
            type: 1
          });
          this.$nextTick(()=> {
            this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight;
          })
          this.params.content = '';
        }
      })
    }
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    Infos() {
      return this.$store.state.Infos;
    },
  },
  watch: {
    $route: {
      handler(val) {},
      deep: true,
    },
    Infos(val) {
      this.Info = val;
    },
  },
};
</script>

<style lang="scss">
$mobil_base: 750;

@function vw($true) {
  @return ($true / $mobil_base) * 100vw;
}

.InMailDetail {
  .InMailDetail-content { padding: vw(40); background: #F2F5F7; min-height: calc( 100vh - 13.3333vw);}
  .InMailList-d-s-title { font-size: vw(29); padding-bottom: vw(18); border-bottom: 1px #7E3D9D solid; margin-bottom: vw(40); }
  .InMailList-d-s-deta { margin-bottom: vw(30); width: 100%; text-align: center;}
  .InMailList-d-s-content-icon { min-width: vw(64); width: vw(64); height: vw(64); border-radius: 50%; border: 1px #ccc solid; margin-right: vw(30); }
  .InMailList-d-s-content-icon img {width: vw(40); height: vw(40);}

  .chat-box {padding: vw(20); border-radius: vw(10); height: calc(100vh - 50vw); overflow-y: auto;}
  .chat-item {margin-bottom: vw(30); display: flex; align-items: center; flex-direction: column;}
  .chat-item-left {align-items: flex-start;}
  .chat-item-right {align-items: flex-end;}
  .chat-item-right .InMailList-d-s-content-icon {order: 1;margin-right: 0;}
  .chat-item-right .InMailList-d-s-content-text {margin-left: 0; margin-right: vw(30);}
  .chat-input {padding: vw(20); background: #fff; border-radius: vw(10);}
  .chat-input-content {display: flex; align-items: center;}
  .chat-input-content input {flex: 1; height: vw(80); border: 1px #ccc solid; border-radius: vw(10); padding: 0 vw(20);}
  .chat-input-content button {width: vw(100); height: vw(80); border: none; background: #7E3D9D; color: #fff; border-radius: vw(10); margin-left: vw(20);}

  .InMailList-d-s-content-text { background: #fff; width: 100%; padding: vw(30); border-radius: vw(10); position: relative;}
  .san0 {width: 0;height: 0;border-top: vw(14) solid transparent;border-right: vw(30) solid #fff;border-bottom: vw(14) solid transparent; position: absolute; left: vw(-14); top: vw(15);}
  .san1 {width: 0;height: 0;border-top: vw(14) solid transparent;border-left: vw(30) solid #fff;border-bottom: vw(14) solid transparent; position: absolute; right: vw(-14); top: vw(15);}

  .InMailList-d-s-content-text .p-top {margin-top: vw(10);}
  .InMailList-d-s-content-text{
    .rich-box {
      max-width: 100%;
      border: 1px #3C1A52 solid;
      border-radius: vw(12);
      padding: vw(12);
      .rich-img {
        width: auto;
        height: vw(80);
        object-fit: contain;
      }
      .rich-title, .rich-title-en {
        font-size: vw(28);
        line-height: 1.5;
        color: #000;
        font-weight: bold;
        margin-bottom: vw(4);
      }
      .rich-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .rich-left {
        font-size: vw(20);
        line-height: 1.5;
        color: #000;
        width: calc( 100% - vw(160) );
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .rich-right {
        width: vw(160);
        height: auto;
        object-fit: contain;
      }
    }
  }

}

@media (max-width: 768px) {
}
</style>